import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useLang } from "@/i18n";
import { SERVICES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm({ kind = "contact", defaultService = "", dark = false }) {
    const { t, lang } = useLang();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        name: "", email: "", phone: "", service: defaultService, subject: "", message: "",
    });

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) {
            toast.error(t.form.required);
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API}/contact`, { ...form, kind });
            toast.success(t.form.success);
            setForm({ name: "", email: "", phone: "", service: defaultService, subject: "", message: "" });
        } catch (err) {
            toast.error(t.form.error);
        } finally {
            setLoading(false);
        }
    };

    const inputBase = dark
        ? "bg-white/5 border-white/15 text-white placeholder:text-slate-500 focus:border-cb-accent"
        : "bg-white border-slate-200 text-cb-dark placeholder:text-slate-400 focus:border-cb-accent";
    const cls = `w-full rounded-none border px-4 py-3.5 text-sm outline-none transition-colors focus:ring-2 focus:ring-cb-accent/30 ${inputBase}`;

    return (
        <form onSubmit={submit} data-testid="contact-form" className="space-y-4">
            <div className="grid gap-4 sm:grid-cols-2">
                <input data-testid="form-name" className={cls} placeholder={t.form.name + " *"} value={form.name} onChange={set("name")} />
                <input data-testid="form-email" type="email" className={cls} placeholder={t.form.email + " *"} value={form.email} onChange={set("email")} />
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
                <input data-testid="form-phone" className={cls} placeholder={t.form.phone} value={form.phone} onChange={set("phone")} />
                <select data-testid="form-service" className={cls} value={form.service} onChange={set("service")}>
                    <option value="">{t.form.selectService}</option>
                    {SERVICES.map((s) => (
                        <option key={s.slug} value={s[lang].name}>{s[lang].name}</option>
                    ))}
                </select>
            </div>
            <input data-testid="form-subject" className={cls} placeholder={t.form.subject} value={form.subject} onChange={set("subject")} />
            <textarea data-testid="form-message" rows={5} className={cls} placeholder={t.form.message + " *"} value={form.message} onChange={set("message")} />
            <button
                data-testid="form-submit-btn"
                type="submit"
                disabled={loading}
                className="cb-glow w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-cb-accent hover:bg-cb-accentHover text-white px-8 py-4 font-medium transition-colors disabled:opacity-60"
            >
                {loading ? t.form.sending : t.form.send}
                {!loading && <Send size={16} />}
            </button>
        </form>
    );
}
